<prlw-layout>
  <router-outlet prlwRouterOutlet></router-outlet>
  <prlw-mobile-footer *ngIf="xsmall$ | async"></prlw-mobile-footer>
  <prlw-preloader-circle></prlw-preloader-circle>
</prlw-layout>
